import {NgModule} from '@angular/core';
import {GallerySubItemComponent} from "./gallery-items/gallery-sub-item.component";
import {HighConversionPageComponent} from "./hcp/high-conversion-page.component";
import {SharedModule} from "../../shared.module";
import {MarketingPageRoutingModule} from "./marketing-page-routing.module";
import {HeroComponent} from "./hero/hero.component";
import {CheckerboardComponent} from "./checkerboard/checkerboard.component";
import {GalleryComponent} from "./gallery/gallery.component";
import {ShareLinkComponent} from "./share-link/share-link.component";
import {PageNotFoundComponent} from "./page-not-found/page-not-found.component";
import {FormsModule} from "@angular/forms";
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {TimepickerModule} from "ngx-bootstrap/timepicker";
import {VideoComponent} from "./video/video.component";
import {FaqComponent} from "./faq/faq.component";
import {DuoToneComponent} from "./duo-tone/duo-tone.component";
import {PageEmbedComponent} from "./embed/page-embed.component";
import {HorizontalCardComponent} from "./horizontal-card/horizontal-card.component";
import {GalleryCardsComponent} from "./gallery-cards/gallery-cards.component";
import {GallerySubCardsComponent} from "./gallery-sub-cards/gallery-sub-cards.component";
import {LandingAdHeroComponent} from "./placeholder/landing-ad-hero/landing-ad-hero.component";
import {LandingAdSideBySideComponent} from "./placeholder/landing-ad-side-by-side/landing-ad-side-by-side.component";
import {LandingAdHeroBaseComponent} from "./placeholder/landing-ad-hero-base/landing-ad-hero-base.component";
import {LandingAdHeroGuidedComponent} from "./placeholder/landing-ad-hero-guided/landing-ad-hero-guided.component";
import {PagePreviewComponent} from "./page-preview/page-preview.component";

@NgModule({
    imports: [
        SharedModule,
        MarketingPageRoutingModule,
        FormsModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot()
    ],
    exports: [
        PageEmbedComponent
    ],
    declarations: [
        CheckerboardComponent,
        DuoToneComponent,
        FaqComponent,
        GalleryCardsComponent,
        GalleryComponent,
        GallerySubCardsComponent,
        GallerySubItemComponent,
        HeroComponent,
        HorizontalCardComponent,
        HighConversionPageComponent,
        LandingAdHeroBaseComponent,
        LandingAdHeroComponent,
        LandingAdHeroGuidedComponent,
        LandingAdSideBySideComponent,
        PageEmbedComponent,
        PageNotFoundComponent,
        PagePreviewComponent,
        ShareLinkComponent,
        VideoComponent
    ]
})
export class MarketingPageModule {
}
